<template>
	<div>
		<!-- Sentinel to know when to show save form bar as fixed/static -->
		<div v-intersect="onIntersect"></div>

		<component
				:is="isIntersecting ? 'ui-box' : 'div'"
				:class="{
					'fixed save-form-wrapper': !isIntersecting,
				}"
				innerClasses="align-center d-flex"
				:style="{ left: `${left}px` }"
				v-resize="getLeftPosition"
		>
			<v-container class="pa-0">
				<v-row>
					<v-col>
						<div
								class="align-center d-flex"
								:class="{ 'px-4 py-4': !isIntersecting }"
						>
							<div
									v-if="$vuetify.breakpoint.smAndUp"
									class="flex-grow-1 me-0 me-sm-4 me-md-8 text-body-2"
							>
							</div>
							<v-btn
									class="rounded-lg"
									color="grey darken-1"
									depressed
									text
									@click="$emit('cancel-action', true)"
							>
								{{ cancelText }}
							</v-btn>
						</div>
					</v-col>
				</v-row>
			</v-container>
		</component>

	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
	name: "SaveForm",
	props: {
		cancelText: {
			type: String,
			default: 'Cancel'
		},
		refs: {
			type: Object,
			required: true
		},
		prevText: {
			type: String,
			default: ''
		},
	},
	data() {
		return {
			boxClass: '',
			fixed: undefined,
			forms: [],
			isIntersecting: undefined,
			left: 0
		}
	},
	methods: {
		getLeftPosition() {
			let newLeft = 0;
			const secondaryNavEl = document.getElementById('secondary-nav');
			const sideNavEl = document.getElementById('side-nav');
			const sideNavState = {
				hover:
						this.$vuetify.breakpoint.smOnly ||
						this.$vuetify.breakpoint.mdOnly ||
						(!this.$vuetify.breakpoint.xs && !!secondaryNavEl),
				temporary: this.$vuetify.breakpoint.xs,
				permanent: this.$vuetify.breakpoint.smAndUp
			};
			const secondaryNavState = {
				temporary: this.$vuetify.breakpoint.mdAndDown,
				permanent: this.$vuetify.breakpoint.lgAndUp
			};

			if(!!sideNavEl && sideNavState.permanent && !sideNavState.hover) newLeft += 256;
			if(!!sideNavEl && sideNavState.hover) newLeft += 56;
			if(!!secondaryNavEl && secondaryNavState.permanent) newLeft += 300;

			this.left = this.isIntersecting ? 0 : newLeft;
		},
		onIntersect(entries, observer, isIntersecting) {
			this.fixed = !isIntersecting;
			this.isIntersecting = isIntersecting;
		}
	},
	mounted() {
		this.getLeftPosition();

		this.forms = Object.keys(this.refs)
				.filter(refKey => {
					return this.refs[refKey] !== null
							&& this.refs[refKey] !== undefined
							&& this.refs[refKey] !== []
							&& refKey.endsWith('Form');
				})
				.map(refKey => {
					if(Array.isArray(this.refs[refKey])) {
						return this.refs[refKey][0];
					}
					return this.refs[refKey];
				});
	},
};
</script>

<style lang="scss" scoped>
.save-form-wrapper {
	background: white;
	border: solid 1px #c9f6b1 !important;
	border-radius: 1rem;
	height: 77px;
	position: static;
	transition: left 300ms ease-in-out;

	&.fixed {
		border: none !important;
		border-radius: 0;
		border-top: solid 1px #e4e4e4 !important;
		bottom: 0;
		box-shadow: 0 0 16px 16px rgba(255, 255, 255, 0);
		position: fixed;
		right: 0;
		transition: box-shadow 0.3s ease-in-out;

		&.is-dirty {
			border-top: none !important;
			box-shadow: 0 0 16px 16px rgba(255, 127, 0, 0.12);
		}
	}
}

::v-deep .v-progress-linear {
	&.save-progress {
		margin-bottom: 14px !important;
		margin-top: -16px !important;
		position: relative;
	}

	&.save-progress-fixed {
		margin-bottom: -2px !important;
		margin-top: 0 !important;
	}

	&[class*="save-progress"] {

		&::after,
		&::before {
			bottom: 0;
			content: '';
			height: 2px;
			position: absolute;
			width: 20%;
			z-index: 1;
		}

		&::before {
			background: linear-gradient(to right, #FFF, rgba(255, 255, 255, 0));
			left: 0;
		}

		&::after {
			background: linear-gradient(to left, #FFF, rgba(255, 255, 255, 0));
			right: 0;
		}
	}
}
</style>